<template>
  <div class="vipProportion">
    <div class="vipProportion-name">
      <span>会员占比趋势</span>
    </div>
    <el-radio-group v-model="radio1" size="small">
      <el-radio-button label="1">普通卡</el-radio-button>
      <el-radio-button label="2">金卡</el-radio-button>
    </el-radio-group>
    <div id="vipProportionBox" style="width: 100%;height: 300px;"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  data() {
    return {
      radio1: "1"
    };
  },
  mounted() {
    this.initMapData();
  },
  methods: {
    initMapData() {
      console.log(1212);
      this.vipProportion = echarts.init(
        document.getElementById("vipProportionBox")
      );

      // 指定图表的配置项和数据
      var option = {
        tooltip: {
          //设置tip提示
          trigger: "axis"
        },
        grid: {
          // 图格配置
          left: "40px",
          right: "30px",
          bottom: "40px"
        },
        legend: {
          //设置区分（哪条线属于什么）
          data: ["注册会员"]
        },
        color: ["#3AA1FF"], //设置区分（每条线是什么颜色，和 legend 一一对应）
        xAxis: {
          //设置x轴
          type: "category",
          alignWithLabel: true,
          boundaryGap: true, //坐标轴两边不留白
          data: [
            "2019-1-1",
            "2019-2-1",
            "2019-3-1",
            "2019-4-1",
            "2019-5-1",
            "2019-6-1",
            "2019-1-1",
            "2019-2-1",
            "2019-3-1",
            "2019-4-1",
            "2019-5-1",
            "2019-6-1",
            "2019-7-1"
          ],
          name: "", //X轴 name
          nameTextStyle: {
            //坐标轴名称的文字样式
            color: "#3AA1FF",
            fontSize: 16,
            padding: [0, 0, 0, 20]
          },
          axisLine: {
            //坐标轴轴线相关设置。
            lineStyle: {
              color: "#3AA1FF"
            }
          }
        },
        yAxis: {
          name: "",
          nameTextStyle: {
            color: "#3AA1FF",
            fontSize: 16,
            padding: [0, 0, 10, 0]
          },
          max: 600,
          axisLine: {
            lineStyle: {
              color: "#3AA1FF"
            }
          },
          type: "value"
        },
        series: [
          {
            name: "注册会员",
            data: [120, 200, 150, 80, 70, 110, 130, 120, 200, 150, 80, 70, 110],
            type: "bar",
            lineStyle: {
              normal: {
                color: "#3AA1FF"
              }
            }
          }
        ]
      };

      // 使用刚指定的配置项和数据显示图表。
      this.vipProportion.setOption(option);
    }
  }
};
</script>

<style lang="scss" scoped>
.vipProportion {
  padding: 16px;
  background: #fff;
  margin-bottom: 14px;

  .vipProportion-name {
    font-size: 20px;
    font-weight: 500;
    line-height: 24px;
    height: 24px;
    margin-bottom: 20px;
  }
  .vipProportionHint {
    padding: 16px;
    display: flex;
    background: #f7f8fa;
    .vipProportionHint_img {
      width: 30px;
      img {
        width: 100%;
      }
    }
    .vipProportionHint_Cont {
      margin-left: 20px;
      height: 48px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
    }
  }
}
</style>
